module.exports = __webpack_public_path__ + "img/close-editor.2b0c1c28.svg";